import React from 'react';
import LayerRow from './LayerRow';

/**
 * Layer table component with section headers for new and legacy conventions
 * @param {Object} props - Component props
 * @param {Object} props.groupedLayers - Layers grouped by runtime
 * @param {function} props.onCopy - Function to handle copy action
 * @returns {JSX.Element} Single table with all layers
 */
function LayerTable({ groupedLayers, onCopy }) {
  const runtimes = Object.keys(groupedLayers).sort();
  const allLayers = runtimes.reduce((acc, runtime) => {
    return acc.concat(groupedLayers[runtime]);
  }, []);

  const newConventionLayers = allLayers.filter(l => l.convention === 'new');
  const legacyConventionLayers = allLayers.filter(l => l.convention === 'legacy');

  return (
    <div className="layers-table-container">
      <table className="layer-table-unified">
        <thead>
          <tr>
            <th>Lambda Runtime</th>
            <th>Architecture</th>
            <th>Extension Version</th>
            <th>New Relic Agent Version</th>
            <th className="arn-column">Layer ARN</th>
            <th className="copy-column">Copy</th>
          </tr>
        </thead>
        <tbody>
          {newConventionLayers.length > 0 && (
            <>
              <tr className="section-header-row">
                <td colSpan={6}>New Convention</td>
              </tr>
              {newConventionLayers.map(layer => (
                <LayerRow key={layer.id} layer={layer} onCopy={onCopy} />
              ))}
            </>
          )}
          {legacyConventionLayers.length > 0 && (
            <>
              <tr className="section-header-row">
                <td colSpan={6}>Old Convention</td>
              </tr>
              {legacyConventionLayers.map(layer => (
                <LayerRow key={layer.id} layer={layer} onCopy={onCopy} />
              ))}
            </>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default LayerTable;
